import { useFocusInvalidField } from "@shared/hooks/useFocusInvalidField";
import { FormElementAttributes } from "@types";
import { toFarsiNumber } from "@utils/digits";
import classNames from "classnames";
import { Field } from "formik";
import { useFormContext } from "./form-context";

interface Props extends FormElementAttributes {
  hasError?: boolean;
}

const RadioInput: React.FC<Props> = (props) => {
  const {
    commonAttrs,
    classes,
    specificAttrs,
    values: options,
    hasError,
  } = props;
  const { name, id } = commonAttrs;
  const use_label_element = specificAttrs.includes("use_label_element");
  const { validate } = useFormContext();
  const { containerElementRef, fieldRef } = useFocusInvalidField(name, true);

  const content = (op: string, index: number) => (
    <>
      <Field
        type={"radio"}
        name={name}
        validate={(v: any) => validate(name, v)}
        id={id}
        value={op}
        className={hasError ? "form-error-validation" : ""}
        innerRef={(el: HTMLElement) => {
          if (index === 0) fieldRef.current = el;
        }}
      />
      <span
        className={classNames("pr-2 font-normal align-middle inline-block")}
      >
        {toFarsiNumber(op)}
      </span>
    </>
  );
  return (
    <span
      className={classNames(
        classes.join(" "),
        props.isRequired ? "form-validate-as-required" : ""
      )}
      ref={containerElementRef}
    >
      {options.map((op, idx) => (
        <span
          key={idx}
          className={classNames(
            "form-check mr-[1em] my-0 ml-0",
            use_label_element ? "px-0 flex flex-col mb-0 mr-6" : "mr-2"
          )}
        >
          {use_label_element ? (
            <label className="mb-0">{content(op, idx)}</label>
          ) : (
            content(op, idx)
          )}
        </span>
      ))}
    </span>
  );
};

export default RadioInput;
